
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutC4J3wQOyM_ybpFwg8u9_JuGH4SvDw3yz5WiQFIuGAJgMeta } from "/var/www/pecom.by/www/frontend/pages/about.vue?macro=true";
import { default as errorRxJd4BBaTCYH3HaQwkk6QpqOyoGyYiwaB3ZvqsvvZT4Meta } from "/var/www/pecom.by/www/frontend/pages/error.vue?macro=true";
import { default as entity_zRLXJRvUfN6JHIUVGDZX_45sDB7aOXa7Nwtnffutf_45g4Meta } from "/var/www/pecom.by/www/frontend/pages/entity.vue?macro=true";
import { default as _91id_93Z2DrGg2pUnWTsWB2mHz0viMv7QMB8n1rrJ97cZeZMdoMeta } from "/var/www/pecom.by/www/frontend/pages/news/[id].vue?macro=true";
import { default as index86rcfvskng_ENgzRfWuNloa7T4mo8SfcBSV4e8yTG5QMeta } from "/var/www/pecom.by/www/frontend/pages/news/index.vue?macro=true";
import { default as index8zajtmrJmMsOgUk3BdWY_yzhrXIw5_jo8KnEWuR0TawMeta } from "/var/www/pecom.by/www/frontend/pages/index/index.vue?macro=true";
import { default as indexfHBnYx4Z7q4e4phEWpC_45vWWk4qsCnEGTE9OSxeUtKn8Meta } from "/var/www/pecom.by/www/frontend/pages/[page]/index.vue?macro=true";
import { default as indexpcJh30vhqGgQlyLvqG0lQ5rA4RJ_XtwgA23_ynthBXcMeta } from "/var/www/pecom.by/www/frontend/pages/package/index.vue?macro=true";
import { default as index3x6P1sEZpVU63gBVBNJx7sFWVc1IDYXQH6qwTcujtB8Meta } from "/var/www/pecom.by/www/frontend/pages/upakovka/index.vue?macro=true";
import { default as indexDdusn3B7wlecc8TlF1rJ_45UxMOGMDiJb8XPgd3zKB1zkMeta } from "/var/www/pecom.by/www/frontend/pages/documents/index.vue?macro=true";
import { default as indexD_d7ydCyp9dd75cliBTo1nLO2ha6b137ei76JkkKM1EMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/index.vue?macro=true";
import { default as hidden_indexdvE28SHs_45mKwkVBG_45Otk0xgrpXc9sFzZ8hrVUv1cgw4Meta } from "/var/www/pecom.by/www/frontend/pages/documents/hidden_index.vue?macro=true";
import { default as getSugggestOpUhPFICViKAFL_9SpaoHwsmvYEhA8QjSXOKIXhlDHcMeta } from "/var/www/pecom.by/www/frontend/pages/index/utils/getSugggest.js?macro=true";
import { default as isProductCodeWU1TP9vIxl0bCsJq_4576xx1y_GjX5PJj6R1WeNEvxWFkMeta } from "/var/www/pecom.by/www/frontend/pages/index/utils/isProductCode.js?macro=true";
import { default as FaqSectiontMOa5JtOMCIqBZ2Hey1n6Iyn24USUOBW_458ZfJKrQRJ4Meta } from "/var/www/pecom.by/www/frontend/pages/index/sections/FaqSection.vue?macro=true";
import { default as MapSectionHgop_45caxGDHkSgN0UZQqKIwQ6B1TPCyYV0fF9TPoc0gMeta } from "/var/www/pecom.by/www/frontend/pages/index/sections/MapSection.vue?macro=true";
import { default as getAddressInfodAvDyu3bwiRfpOWmrSsjV6UGZtG3TV5489fII7YMJvYMeta } from "/var/www/pecom.by/www/frontend/pages/index/utils/getAddressInfo.js?macro=true";
import { default as InfoSectionWrItYw2vR5SpA_45aXOa7XnnPHiZFg0HqZ94z4e5XJ4uYMeta } from "/var/www/pecom.by/www/frontend/pages/index/sections/InfoSection.vue?macro=true";
import { default as BlockTitledcsvDQ2h2Kadhvy4pe1jU0mQLe0plnn4h0A32bLssw0Meta } from "/var/www/pecom.by/www/frontend/pages/index/components/BlockTitle.vue?macro=true";
import { default as ModalError9McmVlEPLbrM1lhTxENzXu12T2rGEm1cJQUUW4xeUYgMeta } from "/var/www/pecom.by/www/frontend/pages/index/components/ModalError.vue?macro=true";
import { default as getNeedCalculategCAXrj0yC_45_45evmhBAOLG46XC0bFjEjm6im2QiPgQJBsMeta } from "/var/www/pecom.by/www/frontend/pages/index/utils/getNeedCalculate.js?macro=true";
import { default as CategoryEYK2VINQVhq3hoGd28J9jpe7zTQYgJLYHDSGvvC3YJMMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/Category.vue?macro=true";
import { default as BlockFaq4TQQa35qvV6uQ1X18nCl2PBA_45dXnLv2qtXTc0qCqB4EMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/BlockFaq.vue?macro=true";
import { default as BannerSlidercwuiFlFyKQj0KmouPKWNKKQz2m_45T2utNfRbU4vK_45e8AMeta } from "/var/www/pecom.by/www/frontend/pages/index/components/BannerSlider.vue?macro=true";
import { default as ModalSuccessY4atM_45EzQIQsZ4x7D_45UEi8TnFnFmH9Y2YuNzudIav5gMeta } from "/var/www/pecom.by/www/frontend/pages/index/components/ModalSuccess.vue?macro=true";
import { default as PalletBlockegsga5rGj65lrSwv513lVfLbs856S7SpYrIeC7C3hPgMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/PalletBlock.vue?macro=true";
import { default as FilialOpenCjQ09Fl2k2e9G95Nmu9fYbv0_T89Kpa5S50Vrk5xsRkMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/FilialOpen.vue?macro=true";
import { default as ModalErrortEeDYJ7MZkBNKJMSuLTnH64hn9FqEh0QB8OZzc3ppdQMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/ModalError.vue?macro=true";
import { default as AdvantageBlockGCUfju2gjmLGyxRE2E42oTY0E2qp92oooDexLPnSfm0Meta } from "/var/www/pecom.by/www/frontend/pages/index/components/AdvantageBlock.vue?macro=true";
import { default as ModalSuccess8ilRb7CSzRR7gtT7FDThbCTnJZ0QM7iyBhWYm7H1JqwMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/ModalSuccess.vue?macro=true";
import { default as ConsultationFormhD5TYBvPeMaIQ3_458u3nSBAjlQERR9aRvvaXjkan6W7EMeta } from "/var/www/pecom.by/www/frontend/pages/index/components/ConsultationForm.vue?macro=true";
import { default as DescriptionSectionevjl1Y_awjTAAeJfw3RQYIlZGl5rTtd1O2_45Z9JUuQlAMeta } from "/var/www/pecom.by/www/frontend/pages/index/sections/DescriptionSection.vue?macro=true";
import { default as CategoryPalletytvQQsP2NE_45UK_4588mpSJUaDo0iABFIEoOYV_rAW8yNQMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/CategoryPallet.vue?macro=true";
import { default as ConsultationBlockigVMZAjkqP2zMq7cByqTeD0ULYNSZ2l5dszWSmvQm_wMeta } from "/var/www/pecom.by/www/frontend/pages/index/components/ConsultationBlock.vue?macro=true";
import { default as FranchiseBlock8DLBQGLQVB3bsEVQvIqQZGaJzZ21cKwMDE0oT0Ft_TMMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/FranchiseBlock.vue?macro=true";
import { default as DefaultHeaderSectionBVUPCHZEmgRz36JLHMYykn3jv5hI4fV9n8V0alvWxQYMeta } from "/var/www/pecom.by/www/frontend/pages/index/sections/DefaultHeaderSection.vue?macro=true";
import { default as ConsultationForm3jy4spOm0QGEMyZq4T6t_45AhqH4Mh40iqgYFGaobxHEcMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationForm.vue?macro=true";
import { default as PalletOnezeG0l7qtle1m0VmGCm6RzF9MY_3cr8TfCl__tOS4ecwMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletOne.vue?macro=true";
import { default as getTransitCostBlockMessageFfmeQqYEQzmpft9HEhgds_aPPKZwwfilGn953VQaleQMeta } from "/var/www/pecom.by/www/frontend/pages/index/utils/getTransitCostBlockMessage.js?macro=true";
import { default as ConsultationBlockbaxcsCxL0mDt9c384ZUaBQ07yhPuqeZd8RQWy_x4abQMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationBlock.vue?macro=true";
import { default as MapBlocknijp2QDxrfBFt4ekLFOkfs1E0AbgakjnE7J97Ij0KeAMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue?macro=true";
import { default as PalletBlockQLct_shv5ZOxC_45Jk6h_45UB4x1BgJ1hlFx7Y0u5_wtc7oMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletBlock.vue?macro=true";
import { default as DefaultAdvantagesSection77DyqTry_45eNKsDQPLl8eqdgmxdxuzMeGi6QRxqNPE6EMeta } from "/var/www/pecom.by/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue?macro=true";
import { default as TableRowcBN_45wcAm7kn59t75P2FJHNI3LVjK6T2nYd1dFX26RvoMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableRow.vue?macro=true";
import { default as PalletBlockDGg2SYkW9x1DWlOSTRDLAmy9T10uSoFvnFxRZuaCsY4Meta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue?macro=true";
import { default as PalletBlockK7uOhRji35jhiOQ9hiUHynVAJUHrZtvWMkAOOAwNDQYMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue?macro=true";
import { default as PekPlusBlockX0iJw6njrIbnnjovXT5ujHrbBPRulPRPv4MVYsJwo98Meta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue?macro=true";
import { default as TableBlockbWCzhv7Qfwr02gM_45lzZbdAqKAuT067tWt5uTn17kxIEMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableBlock.vue?macro=true";
import { default as TableSearchoyIoW5ftWpSrwQmFWjGeGSdW3X_g4P5Zr_45fn5UK_dHMMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableSearch.vue?macro=true";
import { default as getDirectionParamsFromAddressInfoVU1vlmlFHgb9cFSvk_Nr7IjvJQe2jttJdKLlWYumvVMMeta } from "/var/www/pecom.by/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js?macro=true";
import { default as HeadWithSearchSZx9LUs9x7YkctVQwiiplXqcfgymkYgvr0plbPjt4QcMeta } from "/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue?macro=true";
import { default as PartnersBlockeJK6J1Gf_458qTQN3UqvCi4nHEDVZkBHSsGnwj2mzhasAMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue?macro=true";
import { default as BlockDescriptionYZqvhD19EZfow2IjkQDH2Xt4dUPtxEznQmUORtFMmPMMeta } from "/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue?macro=true";
export default [
  {
    name: "about___be",
    path: "/be/about",
    component: () => import("/var/www/pecom.by/www/frontend/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/pecom.by/www/frontend/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/about",
    component: () => import("/var/www/pecom.by/www/frontend/pages/about.vue")
  },
  {
    name: "error___be",
    path: "/be/error",
    component: () => import("/var/www/pecom.by/www/frontend/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/var/www/pecom.by/www/frontend/pages/error.vue")
  },
  {
    name: "error___ru",
    path: "/error",
    component: () => import("/var/www/pecom.by/www/frontend/pages/error.vue")
  },
  {
    name: "entity___be",
    path: "/be/entity",
    component: () => import("/var/www/pecom.by/www/frontend/pages/entity.vue")
  },
  {
    name: "entity___en",
    path: "/en/entity",
    component: () => import("/var/www/pecom.by/www/frontend/pages/entity.vue")
  },
  {
    name: "entity___ru",
    path: "/entity",
    component: () => import("/var/www/pecom.by/www/frontend/pages/entity.vue")
  },
  {
    name: "news-id___be",
    path: "/be/news/:id()",
    meta: {"middleware":"check-news"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()",
    meta: {"middleware":"check-news"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news-id___ru",
    path: "/news/:id()",
    meta: {"middleware":"check-news"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news___be",
    path: "/be/news",
    meta: {"middleware":"clean-store-news"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: {"middleware":"clean-store-news"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/news",
    meta: {"middleware":"clean-store-news"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/news/index.vue")
  },
  {
    name: "index___be",
    path: "/be",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/index.vue")
  },
  {
    name: "index___ru",
    path: "/",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/index.vue")
  },
  {
    name: "page___be",
    path: "/be/:page()",
    meta: {"middleware":"available"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "page___en",
    path: "/en/:page()",
    meta: {"middleware":"available"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "page___ru",
    path: "/:page()",
    meta: {"middleware":"available"},
    component: () => import("/var/www/pecom.by/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "package___be",
    path: "/be/package",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/index.vue")
  },
  {
    name: "package___en",
    path: "/en/package",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/index.vue")
  },
  {
    name: "package___ru",
    path: "/package",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/index.vue")
  },
  {
    name: "upakovka___be",
    path: "/be/upakovka",
    component: () => import("/var/www/pecom.by/www/frontend/pages/upakovka/index.vue")
  },
  {
    name: "upakovka___en",
    path: "/en/upakovka",
    component: () => import("/var/www/pecom.by/www/frontend/pages/upakovka/index.vue")
  },
  {
    name: "upakovka___ru",
    path: "/upakovka",
    component: () => import("/var/www/pecom.by/www/frontend/pages/upakovka/index.vue")
  },
  {
    name: "documents___be",
    path: "/be/documents",
    component: () => import("/var/www/pecom.by/www/frontend/pages/documents/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("/var/www/pecom.by/www/frontend/pages/documents/index.vue")
  },
  {
    name: "documents___ru",
    path: "/documents",
    component: () => import("/var/www/pecom.by/www/frontend/pages/documents/index.vue")
  },
  {
    name: "franchise___be",
    path: "/be/franchise",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "franchise___en",
    path: "/en/franchise",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "franchise___ru",
    path: "/franchise",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "documents-hidden_index___be",
    path: "/be/documents/hidden_index",
    component: () => import("/var/www/pecom.by/www/frontend/pages/documents/hidden_index.vue")
  },
  {
    name: "documents-hidden_index___en",
    path: "/en/documents/hidden_index",
    component: () => import("/var/www/pecom.by/www/frontend/pages/documents/hidden_index.vue")
  },
  {
    name: "documents-hidden_index___ru",
    path: "/documents/hidden_index",
    component: () => import("/var/www/pecom.by/www/frontend/pages/documents/hidden_index.vue")
  },
  {
    name: "index-utils-getSugggest___be",
    path: "/be//utils/getSugggest",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getSugggest___en",
    path: "/en//utils/getSugggest",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getSugggest___ru",
    path: "//utils/getSugggest",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-isProductCode___be",
    path: "/be//utils/isProductCode",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-utils-isProductCode___en",
    path: "/en//utils/isProductCode",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-utils-isProductCode___ru",
    path: "//utils/isProductCode",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-sections-FaqSection___be",
    path: "/be//sections/FaqSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-FaqSection___en",
    path: "/en//sections/FaqSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-FaqSection___ru",
    path: "//sections/FaqSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-MapSection___be",
    path: "/be//sections/MapSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-sections-MapSection___en",
    path: "/en//sections/MapSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-sections-MapSection___ru",
    path: "//sections/MapSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-utils-getAddressInfo___be",
    path: "/be//utils/getAddressInfo",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getAddressInfo___en",
    path: "/en//utils/getAddressInfo",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getAddressInfo___ru",
    path: "//utils/getAddressInfo",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-sections-InfoSection___be",
    path: "/be//sections/InfoSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-InfoSection___en",
    path: "/en//sections/InfoSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-InfoSection___ru",
    path: "//sections/InfoSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-components-BlockTitle___be",
    path: "/be//components/BlockTitle",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-BlockTitle___en",
    path: "/en//components/BlockTitle",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-BlockTitle___ru",
    path: "//components/BlockTitle",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-ModalError___be",
    path: "/be//components/ModalError",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalError___en",
    path: "/en//components/ModalError",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalError___ru",
    path: "//components/ModalError",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-utils-getNeedCalculate___be",
    path: "/be//utils/getNeedCalculate",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getNeedCalculate___en",
    path: "/en//utils/getNeedCalculate",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getNeedCalculate___ru",
    path: "//utils/getNeedCalculate",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "package-components-Category___be",
    path: "/be/package/components/Category",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-Category___en",
    path: "/en/package/components/Category",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-Category___ru",
    path: "/package/components/Category",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "franchise-components-BlockFaq___be",
    path: "/be/franchise/components/BlockFaq",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-BlockFaq___en",
    path: "/en/franchise/components/BlockFaq",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-BlockFaq___ru",
    path: "/franchise/components/BlockFaq",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "index-components-BannerSlider___be",
    path: "/be//components/BannerSlider",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BannerSlider___en",
    path: "/en//components/BannerSlider",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BannerSlider___ru",
    path: "//components/BannerSlider",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-ModalSuccess___be",
    path: "/be//components/ModalSuccess",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ModalSuccess___en",
    path: "/en//components/ModalSuccess",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ModalSuccess___ru",
    path: "//components/ModalSuccess",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "package-components-PalletBlock___be",
    path: "/be/package/components/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-PalletBlock___en",
    path: "/en/package/components/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-PalletBlock___ru",
    path: "/package/components/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "franchise-components-FilialOpen___be",
    path: "/be/franchise/components/FilialOpen",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FilialOpen___en",
    path: "/en/franchise/components/FilialOpen",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FilialOpen___ru",
    path: "/franchise/components/FilialOpen",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-ModalError___be",
    path: "/be/franchise/components/ModalError",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalError___en",
    path: "/en/franchise/components/ModalError",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalError___ru",
    path: "/franchise/components/ModalError",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "index-components-AdvantageBlock___be",
    path: "/be//components/AdvantageBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-AdvantageBlock___en",
    path: "/en//components/AdvantageBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-AdvantageBlock___ru",
    path: "//components/AdvantageBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "franchise-components-ModalSuccess___be",
    path: "/be/franchise/components/ModalSuccess",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-ModalSuccess___en",
    path: "/en/franchise/components/ModalSuccess",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-ModalSuccess___ru",
    path: "/franchise/components/ModalSuccess",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ConsultationForm___be",
    path: "/be//components/ConsultationForm",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ConsultationForm___en",
    path: "/en//components/ConsultationForm",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ConsultationForm___ru",
    path: "//components/ConsultationForm",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-sections-DescriptionSection___be",
    path: "/be//sections/DescriptionSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___en",
    path: "/en//sections/DescriptionSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___ru",
    path: "//sections/DescriptionSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "package-components-CategoryPallet___be",
    path: "/be/package/components/CategoryPallet",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-CategoryPallet___en",
    path: "/en/package/components/CategoryPallet",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-CategoryPallet___ru",
    path: "/package/components/CategoryPallet",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "index-components-ConsultationBlock___be",
    path: "/be//components/ConsultationBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationBlock___en",
    path: "/en//components/ConsultationBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationBlock___ru",
    path: "//components/ConsultationBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___be",
    path: "/be/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___en",
    path: "/en/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___ru",
    path: "/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___be",
    path: "/be//sections/DefaultHeaderSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___en",
    path: "/en//sections/DefaultHeaderSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___ru",
    path: "//sections/DefaultHeaderSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "franchise-components-ConsultationForm___be",
    path: "/be/franchise/components/ConsultationForm",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-ConsultationForm___en",
    path: "/en/franchise/components/ConsultationForm",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-ConsultationForm___ru",
    path: "/franchise/components/ConsultationForm",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___be",
    path: "/be/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___en",
    path: "/en/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___ru",
    path: "/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___be",
    path: "/be//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___en",
    path: "/en//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___ru",
    path: "//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "franchise-components-ConsultationBlock___be",
    path: "/be/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___en",
    path: "/en/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___ru",
    path: "/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___be",
    path: "/be/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___en",
    path: "/en/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___ru",
    path: "/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___be",
    path: "/be/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___en",
    path: "/en/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___ru",
    path: "/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___be",
    path: "/be//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___en",
    path: "/en//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___ru",
    path: "//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___be",
    path: "/be/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___en",
    path: "/en/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___ru",
    path: "/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___be",
    path: "/be/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___en",
    path: "/en/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___ru",
    path: "/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___be",
    path: "/be/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___en",
    path: "/en/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___ru",
    path: "/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___be",
    path: "/be/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___en",
    path: "/en/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___ru",
    path: "/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___be",
    path: "/be/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___en",
    path: "/en/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___ru",
    path: "/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___be",
    path: "/be/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___en",
    path: "/en/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___ru",
    path: "/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___be",
    path: "/be//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___en",
    path: "/en//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___ru",
    path: "//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pecom.by/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___be",
    path: "/be/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___en",
    path: "/en/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___ru",
    path: "/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pecom.by/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___be",
    path: "/be/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___en",
    path: "/en/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___ru",
    path: "/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___be",
    path: "/be/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___en",
    path: "/en/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___ru",
    path: "/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pecom.by/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  }
]